module.exports = __webpack_public_path__ + "static/media/Potié Jérôme - Développeur Web.d8a4053a.pdf";